<div class="depot-list">
  @for (depot of depots; track depot.index) {
    <button class="depot-list__item" type="button" (click)="select(depot.index)">
      <span class="depot-list__number">{{ depot.index + 1 }}</span>
      <span class="depot-list__label">{{ depot.label }}</span>
    </button>
  }
</div>
